/**
 * cc-gallery-fix.js
 * Desktop thumbnail click -> main image change fix (v2 - robust)
 */
(function () {
  'use strict';

  function initGallery() {
    var thumbs = document.querySelectorAll('.cc-thumb');
    var mainImg = document.getElementById('ccMainImg');

    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb, idx) {
      // Prevent double-attach
      if (thumb._galleryAttached) return;
      thumb._galleryAttached = true;

      thumb.addEventListener('click', function () {
        // Get data-full attribute (set in Liquid)
        var fullSrc = thumb.getAttribute('data-full');
        var dataIdx = parseInt(thumb.getAttribute('data-idx'));
        var realIdx = isNaN(dataIdx) ? idx : dataIdx;

        if (!fullSrc) {
          // Fallback: build from thumb img src
          var thumbImg = thumb.querySelector('img');
          if (thumbImg) {
            fullSrc = thumbImg.src.replace(/width=\d+/, 'width=900');
          }
        }

        if (fullSrc) {
          // Clear srcset first so browser doesn't use cached version
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = fullSrc;
        }

        // Update active state on desktop thumbs
        document.querySelectorAll('.cc-thumb').forEach(function (t) {
          t.classList.remove('active');
        });
        thumb.classList.add('active');

        // Sync mobile gallery (index-based)
        if (typeof window.ccMobGoTo === 'function') {
          window.ccMobGoTo(realIdx);
        }
      });
    });
  }

  // Run on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
  });

  // Also run after delay for safety (deferred scripts)
  setTimeout(initGallery, 600);

})();
